import React from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import {t} from "../../../I18n/i18n";
import {RequestState} from "../../../Shared/StateHelper";
import Loader from "../../../Shared/Loader";
import DisplayCard from "../../../Shared/UiKit/DisplayCard";

function ToRedirect({}) {
    const [requestState, setRequestState] = React.useState(RequestState.LOADING)
    const [toRedirectCount, setToRedirectCount] = React.useState(null);

    React.useEffect(() => getToRedirectCount(), [])

    const getToRedirectCount = () => {
        axios.get("/admin/statistiques/api/orthoptist/orthoptist/alerts").then(resp => {
                setToRedirectCount(resp.data.alert_count)
                setRequestState(RequestState.SUCCESS)
            }
        ).catch(() => {
            setRequestState(RequestState.ERROR)
            toast.error(t("ORTHOPTIST_DASHBOARD.TOAST.ERROR.RETRIEVE_ALERTS"))
        })
    }

    const renderToRedirectCount = () => {
        if (requestState === RequestState.LOADING) return <div className="center"><Loader size="small" text=""/></div>
        if (requestState === RequestState.ERROR) return <div>Une erreur est survenue.</div>
        if (requestState === RequestState.SUCCESS) return <h3
            className="valign-wrapper" style={{flex: 1, fontSize: "3em", margin: 0, paddingInline: "0.6em"}}>
            <b>{toRedirectCount}</b>
        </h3>

    }

    return <DisplayCard title="A réorienter" color="red lighten-1" link="/notifications/index">
        {renderToRedirectCount()}
    </DisplayCard>
}

export default ToRedirect;